(function () {
    var bar = document.querySelector('[data-filter-bar]');
    var grid = document.getElementById('work-grid');
    if (!bar || !grid) {
        return;
    }

    var buttons = bar.querySelectorAll('[data-filter]');
    var cards = grid.querySelectorAll('.project-card');

    function applyFilter(slug) {
        for (var i = 0; i < cards.length; i++) {
            var tags = (cards[i].getAttribute('data-tags') || '').split(' ');
            var show = slug === 'all' || tags.indexOf(slug) !== -1;
            cards[i].classList.toggle('is-hidden', !show);
        }

        for (var j = 0; j < buttons.length; j++) {
            var isActive = buttons[j].getAttribute('data-filter') === slug;
            buttons[j].classList.toggle('is-active', isActive);
            buttons[j].setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
    }

    for (var k = 0; k < buttons.length; k++) {
        buttons[k].addEventListener('click', function (e) {
            e.preventDefault();
            var slug = this.getAttribute('data-filter');
            applyFilter(slug);
            if (history.replaceState) {
                var url = slug === 'all' ? '#' : '#' + slug;
                history.replaceState(null, '', location.pathname + url);
            }
        });
    }

    var initial = location.hash ? location.hash.slice(1) : 'all';
    var hasMatch = false;
    for (var m = 0; m < buttons.length; m++) {
        if (buttons[m].getAttribute('data-filter') === initial) {
            hasMatch = true;
            break;
        }
    }
    applyFilter(hasMatch ? initial : 'all');
}());
